<app-partner-description></app-partner-description>